import { render, staticRenderFns } from "./TeaserProperty.vue?vue&type=template&id=05832258&scoped=true&lang=pug&"
import script from "./TeaserProperty.vue?vue&type=script&lang=js&"
export * from "./TeaserProperty.vue?vue&type=script&lang=js&"
import style0 from "./TeaserProperty.vue?vue&type=style&index=0&id=05832258&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05832258",
  null
  
)

export default component.exports